import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { BrowserRouter } from 'react-router-dom';
// testing
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter  basename="/">
    <App />
  </BrowserRouter>
);
